var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChakra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "84.616 100.617 186.636 191.367",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ChakraUI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo",
    x1: 128.5,
    x2: 128.5,
    y2: 257,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.726209, 0, 0, 0.744621, 84.616204, 100.616932)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BCBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29C6B7"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 186.636,
    height: 191.367,
    rx: 128.5,
    fill: "url(#logo)",
    style: {},
    x: 84.616,
    y: 100.617
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 134.336 205.506 L 194.692 149.416 C 195.82 148.368 197.635 149.643 196.873 150.948 L 174.409 189.476 C 173.907 190.335 174.572 191.383 175.618 191.383 L 214.44 191.383 C 215.691 191.383 216.294 192.817 215.38 193.616 L 147.35 253.028 C 146.13 254.093 144.315 252.592 145.294 251.328 L 177.498 209.757 C 178.158 208.904 177.508 207.71 176.382 207.71 L 135.307 207.71 C 134.077 207.71 133.463 206.317 134.336 205.506 Z",
    fill: "#fff",
    style: {}
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChakra);
export default __webpack_public_path__ + "static/media/Chakra.e57ff02b530c68eef53d0e744bbd5946.svg";
export { ForwardRef as ReactComponent };